import styled from 'styled-components';
import { Link } from 'react-router-dom';

const ModalContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	padding: 15px 0 0 0;
`;

const ModalTitle = styled.h5`
	padding: 16px;
	display: flex;
	gap: 10px;
`;

const ModalContentContainer = styled.div`
	width: 80%;
	display: flex;
	text-align: left;
	flex-direction: column;
	gap: 10px;
	padding-bottom: 40px;
`;

const ModalContent = styled.h6`
	font-size: 16px !important;
	font-weight: 400;
	margin: 0 10px;
	line-height: 200%;
`;

const ModalLink = styled(Link)`
	font-size: 16px;
	text-decoration-style: solid;
	font-weight: 700;
	line-height: 200%;
`;

export default {
	ModalContainer,
	ModalTitle,
	ModalContentContainer,
	ModalContent,
	ModalLink
};
